const RESET = 'RESET'

const SET_CONFIGURATION = 'SET_CONFIGURATION'
const SET_SERVICE = 'SET_SERVICE'
const UPDATE_MISSING_PARAMS = 'UPDATE_MISSING_PARAMS'
const SET_SERVICE_ACTIVE = 'SET_SERVICE_ACTIVE'

import {
  SERVICE_LINKS,
} from '@/store/ServiceRegistry/linkedservices'

let initialState = () => ({
  service: null,
  isServiceActive: false,
  usersDetail: {},
  totalQueries: 0,
  configuration: {},
  missingParams: {
    stations: [],
    guidelines: [],
  },
})

function payloadToConfiguration({
  recipients,
  reportParams,
}) {
  let params = JSON.parse(reportParams)
  return {
    recipients,
    ...params,
  }
}

function configurationToPayload({
  recipients,
  ...reportParams
}) {
  return {
    recipients,
    reportParams: JSON.stringify(reportParams),
  }
}

export default {
  namespaced: true,
  state: initialState,
  actions: {
    async fetchConfiguration({
      commit,
      dispatch,
      getters,
    }, {
      tenantId,
      params,
    } = {}) {
      try {
        const response = await dispatch('serviceconfigurations/fetchTenantConfigurations', {
          tenantId,
          params,
          service: getters.service,
        }, {
          root: true,
        })

        let payload = response.data

        if (!payload) return

        let configuration = payloadToConfiguration(payload)
        commit(SET_CONFIGURATION, configuration)
        return configuration
      } catch (e) {
        console.error(e)
        throw e
      }
    },
    async fetchService({
      commit,
      dispatch,
    }) {
      try {
        let service = await dispatch('linkedservices/getServiceByLink', {
          serviceLink: SERVICE_LINKS.DISCRETE_IMPORT_EXCEEDANCE_NOTIFICATIONS,
        }, {
          root: true,
        })

        commit(SET_SERVICE, service)
      } catch (error) {
        console.error(error)
        throw error
      }
    },
    async pingService({
      commit,
      getters,
      dispatch,
    }) {
      if (!getters.service) {
        commit(SET_SERVICE_ACTIVE, false)
        return
      }

      let serviceId = getters.service.Id
      let pingResponse = await dispatch('services/pingServices', {
        serviceId,
      }, {
        root: true,
      })

      commit(SET_SERVICE_ACTIVE, pingResponse.Active)
    },
    async updateConfiguration({
      commit,
      dispatch,
      getters,
    }, {
      configuration,
    }) {
      try {
        let configurationPayload = configurationToPayload(configuration)

        let response = await dispatch('serviceconfigurations/updateConfiguration', {
          configuration: configurationPayload,
          service: getters.service,
        }, {
          root: true,
        })

        let payload = response.data
        let configurationResponse = payloadToConfiguration(payload)

        commit(SET_CONFIGURATION, configurationResponse)
        return configurationResponse
      } catch (e) {
        console.error(e)
        throw e
      }
    },
    updateMissingParams({
      commit,
    }, properties) {
      commit(UPDATE_MISSING_PARAMS, properties)
    },
    clearMissingParams({
      commit,
    }) {
      commit(UPDATE_MISSING_PARAMS, initialState().missingParams)
    },
  },
  mutations: {
    [SET_SERVICE_ACTIVE](state, active) {
      state.isServiceActive = active
    },
    [UPDATE_MISSING_PARAMS](state, properties) {
      state.missingParams = {
        ...state.missingParams,
        ...properties,
      }
    },
    [SET_CONFIGURATION](state, configuration) {
      state.configuration = configuration
    },
    [SET_SERVICE](state, service) {
      state.service = service
    },
    [RESET](state) {
      const s = initialState()
      Object.keys(s).forEach(key => {
        state[key] = s[key]
      })
    },
  },
  getters: {
    service: (state) => state.service,
    configuration: (state) => state.configuration,
    isServiceActive: (state) => state.isServiceActive,
    missingParams: (state) => state.missingParams,
  },
}